export const MAX_SURCHARGE_PERCENT = 999;
